import { Component, Input } from '@angular/core'

import { Task, UserTask } from '@mprep/shared/data/models'
import { UserTaskService } from '@mprep/shared/data/services'

@Component({
  selector: 'mp-default-task-flag',
  templateUrl: './task-flag.html',
  styleUrls: ['./task-flag.scss']
})
export class TaskFlagComponent {

  @Input() public userTask: UserTask
  @Input() public isSubtask: boolean
  @Input() public totalFlaggedSubtasks: number

  constructor(
    private _userTaskService: UserTaskService
  ) {}

  public toggleFlag() {
    if (!this.userTask) {
      return
    }

    this.userTask.setNextFlag()
    this._userTaskService.save(this.userTask).subscribe()
  }

  public flagStatusCssClass() {
    const flaggedStatus = (!this.userTask || !this.userTask.flagged) && this.totalFlaggedSubtasks ?
      1 : this.userTask.flagged || 0
    return `flagged-status-${flaggedStatus}`
  }

  public hasFlaggedSubtasksAndIsNotFlagged() {
    return this.totalFlaggedSubtasks && (!this.userTask || !this.userTask.flagged)
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/task-flag/task-flag.component.ts